/** Invokes `.trim()` on the provided string. Can be passed as an iteratee to `.map`. */
export function trimToken(token: string): string {
  return token.trim();
}
